// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___m_Q39","root__image":"style-module__root__image___dyqNu","root__image_hide":"style-module__root__image_hide___gRfmV","root__wrapper":"style-module__root__wrapper___DETz3","root__wrapper_art":"style-module__root__wrapper_art___H3ap4","root__wrapper_btn":"style-module__root__wrapper_btn___NhhEc"};
    if(module.hot) {
      // 1729151129831
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  